import Vue from 'vue';
import GtraceBrowser from '@weiyi/gtrace-browser';

// eslint-disable-next-line object-curly-newline
import {
  List,
  Toast,
  Tab,
  Tabs,
  PullRefresh,
  Icon,
  Popup,
  Lazyload,
  Image as VanImage,
  Field,
  Form,
  Radio,
  RadioGroup,
  Button,
  Dialog,
  Uploader,
  DatetimePicker,
  Picker,
  Checkbox,
  CheckboxGroup,
  Overlay,
  Swipe,
  SwipeItem,
  Loading,
  ActionSheet,
  CountDown,
  Divider,
} from 'vant';
import Clipboard from 'v-clipboard';
import clampy from '@clampy-js/vue-clampy';
import VueWechatTitle from 'vue-wechat-title';
import 'amfe-flexible';

import '@/assets/less/reset.less';
import '@/assets/less/common.less';

import FastClick from 'fastclick';

// eslint-disable-next-line import/no-extraneous-dependencies
import VConsole from 'vconsole';
import { getUA } from '@weiyi/ua';
import bridge from '@weiyi/bridge';
import Meta from 'vue-meta';
import player from '@/components/player/index.vue';
import { openApp, isWeChatClient } from '@/assets/utils/utils';
import videoLoading from '@/components/video/video-loading/index.vue';
import App from './App.vue';
import router from './router/intercept';
import store from './store';

Vue.use(Meta);

// 调用APP的方法
const ua = getUA();
Vue.prototype.$bridge = bridge;
Vue.prototype.$UA = ua;
Vue.prototype.$pub = new Vue();

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-new
  new VConsole();
}

const loading = require('./assets/icon/loading-img.png');
const error = require('./assets/icon/loading-img.png');

FastClick.attach(document.body);

Vue.config.productionTip = false;
Vue.use(Toast)
  .use(clampy)
  .use(Tab)
  .use(List)
  .use(Tabs)
  .use(VueWechatTitle)
  .use(Icon)
  .use(PullRefresh)
  .use(Popup)
  .use(VanImage)
  .use(Clipboard)
  .use(Field)
  .use(Form)
  .use(Radio)
  .use(RadioGroup)
  .use(Button)
  .use(Dialog)
  .use(Uploader)
  .use(Picker)
  .use(DatetimePicker)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Overlay)
  .use(Swipe)
  .use(SwipeItem)
  .use(Loading)
  .use(ActionSheet)
  .use(CountDown)
  .use(Divider)
  .use(Lazyload, {
    loading,
    error,
  });

Vue.component(player.name, player);
Vue.component(videoLoading.name, videoLoading);

Vue.prototype.$openApp = openApp;
Vue.prototype.$isWeChatClient = isWeChatClient;

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// eslint-disable-next-line no-new
new GtraceBrowser({
  serviceName: 'doctor-bridge-h5-static',
  mode: 'page',
  plugin: ['vue', app],
  exclude: ['.m3u8', '.ts', 'blob', '.mp4'],
});
